import React, { useState, useEffect } from 'react';
import {  Grid } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { TitlePage } from '@src/@styles/styles.global';
import InvisibleContent from '@src/components/Shared/InvisibleContent';
import LotePendentes from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/ListLotesPendentes';
import LoteReaberto from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/ListLotesReabertas';
import LoteAberto from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes/ListLotesAbertos';




const ListLotes: React.FC = () => {
  const [status, setStatus] = useState('');

  const [openPendentes, setOpenPendentes] = useState(false);
  const [openReabertos, setOpenReabertos] = useState(false);
  const [openAbertos, setOpenAbertos] = useState(false);




  useEffect(() => {
    window.document.title = 'CRM - Listagem lotes';
  }, []);

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Listagem de doações por lotes</TitlePage>
      </Grid>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            //onClick={() => setOpenModalAddCorrespondencia(true)}
            fullWidth
            style={{ height: 46, borderRadius: 5 }}
            color={status === 'Pendentes' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Pendentes'), setOpenPendentes(true), setOpenReabertos(false), setOpenAbertos(false))}
          >
            Lotes fechados
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Reabertos' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Reabertos'), setOpenReabertos(true), setOpenPendentes(false), setOpenAbertos(false))}
          >
            Lotes reabertos
          </ButtonComponent>
        </Grid>

        <Grid item lg={2} md={2} xs={4} style={{ margin: 5 }}>
          <ButtonComponent
            fullWidth
            style={{ height: 46, borderRadius: 5}}
            color={status === 'Abertos' ? 'secondary' : 'default'}
            onClick={() => (setStatus('Abertos'), setOpenAbertos(true), setOpenPendentes(false), setOpenReabertos(false))}
          >
            Lotes abertos
          </ButtonComponent>
        </Grid>


        <InvisibleContent visible={openPendentes === true}>
          <LotePendentes />
        </InvisibleContent>

        <InvisibleContent visible={openReabertos === true}>
        <LoteReaberto />
        </InvisibleContent>

        <InvisibleContent visible={openAbertos === true}>
        <LoteAberto />
        </InvisibleContent>




      </Grid>

    </Grid>
  );
};

export default ListLotes;
